export class SupplierTicket {
  public ID: number;
  public FullName: string;
  public Email: string;
  public TicketNo: string;
  public Department: string;
  public Priority: string;
  public Subject: string;
  public Message: string;
  public SubmittedBy: number;
  public StatusID: string;
  public CreatedDatetime: string;
  public LastUpdatedDatetime: string;
  public StatusChangeRemarks: string;
  public TicketReply: Array<TicketReply>;
  
}
export class TicketReply {
  public ID: number;
  public SupplierTicketID: number;
  public ReplyMessage: string;
  public ReplyBy: number;
  public CreatedDateTime: string;
  public FilePath :string;

}



// WEBPACK FOOTER //
// ./src/app/models/SupplierTicket/SupplierTicket-model.ts